export default function Check() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 21.68L14.9956 28.6755C15.1418 28.8214 15.3786 28.8217 15.5247 28.6755L32.2 12"
        stroke="currentColor"
        strokeWidth="4.84"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
